import { render, staticRenderFns } from "./CreateSupplierView.vue?vue&type=template&id=718f3c86&scoped=true&"
import script from "./CreateSupplierView.vue?vue&type=script&lang=ts&"
export * from "./CreateSupplierView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "718f3c86",
  null
  
)

export default component.exports